import { WEI_PER_SPARK } from '../sparks'

export const MINT_FEE_IN_SPARKS = 111n
export const MINT_FEE = MINT_FEE_IN_SPARKS * WEI_PER_SPARK

export const MARKET_REWARD_LEGACY = 11100000000000n
export const MARKET_REWARD = 22200000000000n
// the default secondary market countdown duration (1 days)
export const MARKET_COUNTDOWN_DEFAULT = 24 * 60 * 60
// the default amount of mints required to start the secondary market countdown
export const MARKET_MINTS_DEFAULT = 1111n
export const MINIMUM_MARKET_ETH_DEFAULT = MARKET_MINTS_DEFAULT * MARKET_REWARD

export const MARKET_REWARD_UPDATE_TIMESTAMP = 1733940659 * 1000
